import { InputHTMLAttributes } from 'react';

import './ToggleButton.scss';

interface ToggleButtonProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked'> {
  selected: boolean;
  size?: number;
}

export function ToggleButton(
  { title, size, ...props }: ToggleButtonProps) {
  return (
    <label
      className="toggle-button"
      style={{ '--toggle-button-size': (size ?? 2.5) + 'rem' }}
      title={title}
    >
      <input
        type="checkbox"
        {...props}
        defaultChecked={props.selected}
      />
    </label>
  );
}

